import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import CVisionBoardDashboard from '../VisionBoard/CVisionBoardDashboard';
import { SidebarContext } from '../../../../context/SidebarContext';
import { getLocalStorageItem } from '../../../../utils/helper';

/**
 * Self Development → Vision Board tab.
 *
 * The Vision Board dashboard itself is unchanged — this only re-parents it and
 * adds the one link the move would otherwise cost. Vision Board keeps a
 * per-person page of its own (board sizes, reminders, empty boards) that the
 * section-wide Employees table can't carry, and with no tab of its own it needs
 * a way in from here.
 */
const CSelfDevVisionBoard = () => {
  const navigate = useNavigate();
  const { isB2BFansMode } = useContext(SidebarContext);
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  return (
    <div>
      <div className="flex justify-end mb-3">
        <button
          type="button"
          className="text-sm font-medium text-shoorah-active hover:underline"
          onClick={() => navigate(`/${slug}/self-development/vision-board/users`)}
        >
          Board activity per {isB2BFansMode ? 'member' : 'employee'} →
        </button>
      </div>
      <CVisionBoardDashboard />
    </div>
  );
};

export default CSelfDevVisionBoard;
